import { useState } from "react";
import { CreateSessionResponse } from "src/api";

export interface DepositState {
  // Amount state
  amount: string;
  amountTouched: boolean;

  // Loading and error state
  initiateDepositLoading: boolean;
  initiateDepositError: string | null;

  // Session state
  sessionData: CreateSessionResponse | null;
}

export const useDepositState = () => {
  // Amount state
  const [amount, setAmount] = useState<string>("");
  const [amountTouched, setAmountTouched] = useState(false);

  // Loading and error state
  const [initiateDepositLoading, setInitiateDepositLoading] = useState(false);
  const [initiateDepositError, setInitiateDepositError] = useState<string | null>(null);

  // Session state
  const [sessionData, setSessionData] = useState<CreateSessionResponse | null>(null);

  return {
    // Amount state
    amount,
    setAmount,
    amountTouched,
    setAmountTouched,

    // Loading and error state
    initiateDepositLoading,
    setInitiateDepositLoading,
    initiateDepositError,
    setInitiateDepositError,

    // Session state
    sessionData,
    setSessionData,
  };
};
